import {
  cardDesignFillFormWithStyles,
  cardDesignInitialValues,
  danger,
  datesToISO,
  fileToDataUrl,
  isoToDate,
  parseBoolean,
} from "@";
import { cardDesignInitialValuesForAll } from "./options";

// Add a new gift project attribute
export const addGiftProjectAttribute = async (
  title,
  amount,
  image,
  attributes,
) => {
  if (!title || !amount || !image) {
    await danger("يجب تعبئة جميع حقول الفئة");
    return attributes;
  }

  const imageFile = image.target.files[0];
  const imageUrl = await fileToDataUrl(imageFile);

  return [
    ...attributes,
    {
      title,
      amount,
      image: imageFile,
      imageView: imageUrl,
      giftingCardDesigns: [],
    },
  ];
};

// Fill form with project attributes
export function fillForm(item) {
  if (!item) return {};

  const mapGiftingCardDesigns = (designs) =>
    designs?.length > 0
      ? designs?.map((design) => cardDesignFillFormWithStyles(design))
      : [];

  const giftAttributes = item?.projectAttributes?.map((attribute) => ({
    id: attribute.id,
    title: attribute.title,
    amount: attribute.amount,
    imageFullUrl: attribute.imageFullUrl,
    giftingCardDesigns: mapGiftingCardDesigns(attribute.giftingCardDesigns),
  }));

  return {
    ...item,
    attributes: giftAttributes,
    endsTo: isoToDate(item.endsTo),
    startsFrom: isoToDate(item.startsFrom),
  };
}

// handle gif card attributes
export const processGiftCardAttributes = async (data, formData) => {
  for (const [i, el] of data.attributes.entries()) {
    formData.append(`attributes[${i}].id`, el?.id || 0);
    formData.append(`attributes[${i}].title`, el.title);
    formData.append(`attributes[${i}].price`, el.amount);

    if (el.image) formData.append(`attributes[${i}].image`, el.image);
    if (el.imageFullUrl)
      formData.append(`attributes[${i}].imageFullUrl`, el.imageFullUrl);

    const appendDesignFields = (design, j, i, formData) => {
      const designFields = {
        content: "test",
        show: design.show,
        color: design.color,
        xPercentage: parseInt(design.xWithTextWidth),
        yPercentage: parseInt(design.y),
        fontSize: design.fontSize,
        fontFamily: 4,
        "shadow.x": design.shadowX,
        "shadow.y": design.shadowY,
        alignment: 1,
        hasShadow: design.hasShadow,
        "shadow.blur": design.shadowBlur,
        disclaimer: design.disclaimer,
        "border.color": design.borderColor,
        "shadow.color": design.shadowColor,
        "border.thickness": design.borderThickness,
      };

      Object.entries(designFields).forEach(([key, value]) => {
        formData.append(
          `attributes[${i}].giftingCardDesigns[${j}].${key}`,
          value,
        );
      });
    };

    const giftingCardDesigns =
      el.giftingCardDesigns?.length > 0
        ? el.giftingCardDesigns
        : cardDesignInitialValuesForAll;

    giftingCardDesigns.forEach((design, j) => {
      appendDesignFields(design, j, i, formData);
    });
  }
};

// search values payload for gift projects
export const searchValuesPayload = ({
  title,
  toDate,
  toAmount,
  isActive,
  fromDate,
  fromAmount,
  isArchived,
  isCompleted,
  showInHomePage,
}) => ({
  title,
  toDate: datesToISO(toDate),
  toAmount: parseInt(toAmount),
  fromDate: datesToISO(fromDate),
  fromAmount: parseInt(fromAmount),
  isActive: parseBoolean(isActive),
  isArchived: parseBoolean(isArchived),
  isCompleted: parseBoolean(isCompleted),
  showInHomePage: parseBoolean(showInHomePage),
});

// Initialize gift card design values
export const getCardDesignInitValues = (
  data,
  defaultX,
  defaultY,
  disclaimer,
) => {
  const cardDesign = data.giftingCardDesigns.find(
    (design) => design.disclaimer === disclaimer,
  );
  if (cardDesign) {
    return cardDesign;
  } else {
    return {
      ...cardDesignInitialValues,
      x: parseInt(defaultX),
      y: parseInt(defaultY),
      disclaimer: disclaimer,
    };
  }
};
